// src/services/userService.js
import api, { BASE_URL } from './api';

class UserService {

  // Primary method: fetch users scoped to a specific medical center
  async getUsersByMedicalCenter(medicalCenterId) {
    if (!medicalCenterId) throw new Error('Medical Center ID is required');
    const users = await api.get(`${BASE_URL}/medical_centers/${medicalCenterId}/users`);
 
    return (users || []).map(u => ({ ...u, medical_center_id: medicalCenterId }));
  }

  // Create new user
  async createUser(userData) {
    const newUser = await api.post(`${BASE_URL}/users`, { user: userData });
    return newUser;
  }

  // Update user
  async updateUser(userId, userData) {
    const updatedUser = await api.put(`${BASE_URL}/users/${userId}`, { user: userData });
    return updatedUser;
  }

  // Delete user
  async deleteUser(userId) {
    return await api.delete(`${BASE_URL}/users/${userId}`);
  }

  // Invitation flows
  async inviteUser(userData) {
    return await api.post(`/users/invitation`, { user: userData });
  }

  async getInvitationDetails(invitationToken) {
    return await api.get(`/users/invitation/accept?invitation_token=${invitationToken}`);
  }

  async acceptInvitation(userData) {
    return await api.put(`/users/invitation`, { user: userData });
  }
}

export const userService = new UserService();